<template>

    <article id="cookiewarning" v-if="warn_user">
        <h2>
            Vi vil gerne gemme oplysninger om dit besøg
        </h2>
        <ul>
            <li>
                for at du kan logge ind på sitet
            </li>
            <li>
                og for at du ikke skal se denne besked igen
            </li>
        </ul>

        <p v-if="!show_terms">
            <button class="btn-link" @click="show_terms = !show_terms">Vis mig detaljer om brug af persondata</button>
        </p>
        
        <template v-if="show_terms">
            <terms />
        </template>

        <p class="choice">
            <button @click="setSnooping('accept')" id="cookie-accept">Ja tak</button>
            <!-- 
                Presently, only functionally important localstorage is in use. 
                There are no non-functional cookies to deny
                <button @click="setSnooping('deny')">Nej tak</button>
            -->
        </p>
    </article>

</template>


<script>

    import terms from '../../views/Terms.vue'

    export default {
        components: {
            terms
        },
        data: function() {
            return {
                warn_user: false,
                show_terms: false
            }
        },
        methods: {
            setSnooping: function(consent) {
                localStorage.setItem('booking_app_owns_me', consent)
                this.warn_user = false
            },
            checkAccept: function() {
                if (!localStorage.getItem('booking_app_owns_me')) {
                    this.warn_user = true
                };
            }
        },
        created: function() {
            this.checkAccept()
        }
    }

</script>


<style lang="scss">

    @import "../../styles/vars.scss";

    #cookiewarning {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        padding: 4rem 2rem;
        background-color: $grey10;
        color: $grey0;
        z-index: 1000;
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: center;

        & > * {
            width: 100%;
            max-width: $wide;
            margin: .5rem 1rem;
            flex: 0 1 auto;
        }
        h1 {
            font-size: 1.25rem;
        }
        .choice {
            padding: 0;
        }
        ul {
            padding: 0;
            margin: 1rem 0;
        }
        button {
            margin: 0 .5rem 0 0;
            border-radius: .25rem;
        }
        .btn-link {
            color: $grey4;
        }
        #terms {
            margin: 0;
        }
    }

    @media screen and (min-width: $wide) {

        #cookiewarning {
            box-shadow: 0 -.5rem 0 hsla(0,0%,0%,.3);
            top: auto;
            height: auto;
            //max-height: 100vh;         
        }        

    }

</style>
